import { Routes as LibRoutes, Navigate, Route, useLocation } from 'react-router';
import { useIsBlockchainVersion, useRefCodeHandler } from '../hooks';
import { LayoutWithHeader } from '../layouts/LayoutWithHeader.tsx';
import {
  GamePage,
  HowToPlayPage,
  LeaderBoardPage,
  B2CBlockchainHistoryPage,
  ReplayPage,
} from '../pages';
import { gtmPageView } from '../utils/gtm.ts';
import { useEffect } from 'react';
import { b2bVersion } from '../utils/consts.ts';

// Conditionally export useRefCodeHandler wrapper to avoid calling wagmi hooks in B2B
const useRefCodeHandlerConditional = b2bVersion
  ? () => {
      // No-op in B2B mode - referral codes not supported without wallet
    }
  : useRefCodeHandler;

const Routes = () => {
  const isBlockchainVersion = useIsBlockchainVersion();
  const location = useLocation();

  useRefCodeHandlerConditional();

  // Track page views on route changes
  useEffect(() => {
    const pathToPageName: Record<string, string> = {
      '/game': 'Game Page',
      '/replay': 'Replay Page',
      '/leaderboard': 'Leaderboard Page',
      '/hot-to-play': 'How to Play Page',
      '/blockchain-history': 'Blockchain History Page',
    };

    const pageName = pathToPageName[location.pathname];
    if (pageName) {
      gtmPageView(pageName, location.pathname);
    }
  }, [location.pathname]);

  return (
    <LibRoutes>
      <Route element={<LayoutWithHeader />}>
        <Route index element={<Navigate to="game" replace />} />
        <Route path={'game'} element={<GamePage />} />
        <Route path={'replay'} element={<ReplayPage />} />
        {isBlockchainVersion && (
          <>
            <Route path={'leaderboard'} element={<LeaderBoardPage />} />
            <Route path={'hot-to-play'} element={<HowToPlayPage />} />
            <Route
              path={'blockchain-history'}
              element={<B2CBlockchainHistoryPage />}
            />
          </>
        )}
      </Route>
    </LibRoutes>
  );
};

export { Routes };
